<template>
	<div class="login">
		<div class="infoform">
			<div class="textlogin">
				<span>账号注册</span>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm">
				<el-form-item label="请输入手机号" prop="account">
					<el-input v-model="ruleForm.account" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<!-- <el-form-item label="请输入邮箱" prop="email">
					<el-input v-model="ruleForm.email" placeholder="请输入邮箱(选填)"></el-input>
				</el-form-item> -->
				<el-form-item label="请输入密码" prop="password">
					<el-input v-model="ruleForm.password" placeholder="请输入密码" show-password>
					</el-input>
					<div>
						<span
							style="color: darkgray; font-size: 12px;">8-20位字符，可使用字母、数字或符号的组合，不建议使用纯字母、纯数字、纯符号</span><br />
					</div>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirm">
					<el-input v-model="ruleForm.confirm" placeholder="请确认密码" show-password></el-input>
				</el-form-item>
				<el-form-item prop="code" style="padding-top: 2%;">
					<div class="sendcode">
						<el-input v-model="ruleForm.code" placeholder="验证码"></el-input>
						<el-button @click="getcode()" v-if="!sendMsgDisabled">获取验证码</el-button>
						<el-button v-if="sendMsgDisabled">{{ time+'秒后再次获取' }}</el-button>
					</div>
				</el-form-item>
			</el-form>
			<div class="roundbtn">
				<el-button round class="back_login" @click="backToLogin()">返回登录</el-button>
				<el-button type="primary" round class="lgoinbtn" @click="postregister()">注册</el-button>
			</div>
			<div class="footer">
				<div class="container">
					<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
						技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
						<br />吉公网安备 22010402001082号
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		sendVerifyCodeByMessage,
		addUser,
	} from '../api/user.js'
	export default {
		data() {
			var validateAccount = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入正确手机号'));
				} else if (value.length != 11) {
					callback(new Error('请输入正确手机号'));
				} else {
					callback();
				}
			};
			var validatePassword = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else if (value.length >= 8 && value.length <= 20) {
					if (this.ruleForm.confirm !== '') {
						this.$refs.ruleForm.validateField('confirm');
					}
					callback();
				} else {
					callback(new Error('密码应控制在8-20位'));
				}
			};
			var validateConfirm = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				time: 120,
				sendMsgDisabled: false,
				ruleForm: {
					account: '',
					password: '',
					confirm: '',
					// email: '',
					code: '',
				},
				rules: {
					account: [{
						validator: validateAccount,
						trigger: 'blur'
					}, ],
					password: [{
						validator: validatePassword,
						trigger: 'blur'
					}, ],
					confirm: [{
						validator: validateConfirm,
						trigger: 'blur'
					}, ],
					// email: [{
					// 		required: true,
					// 		message: '请输入邮箱地址',
					// 		trigger: 'blur',
					// 	},
					// 	{
					// 		type: 'email',
					// 		message: '请输入正确的邮箱地址',
					// 		trigger: ['blur', 'change'],
					// 	},
					// ],
				},
			};
		},
		methods: {
			backToLogin() {
				this.$router.push('/login')
			},
			postregister() {
				if (this.ruleForm.account != '' && this.ruleForm.password != '' && this.ruleForm.confirm != '' && this
					.ruleForm.code != '') {
					addUser({
						code: this.ruleForm.code,
						// mailAddress: this.ruleForm.email,
						password: this.ruleForm.confirm,
						phoneNumber: this.ruleForm.account,
						userID: this.ruleForm.account,
					}).then((res) => {
						if (res.code == 200) {
							this.$message({
								message: '注册成功！',
								type: 'success'
							});
							this.$router.push('/login')
						} else if (res.code == 40020) {
							this.$message({
								message: '您的验证码有误！',
								type: 'error'
							});
						} else if (res.code == 40013) {
							this.$message({
								message: '用户名已存在！',
								type: 'warning'
							});
						} else if (res.code == 40018) {
							this.$message({
								message: '您填写的邮件格式有误！',
								type: 'warning'
							});
						}
					})
				} else {
					this.$message({
						message: '非选填项不能为空！',
						type: 'error'
					});
				}
			},
			getcode() {
				sendVerifyCodeByMessage({
					userID: this.ruleForm.account,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '验证码发送成功',
							type: 'success'
						});
						const that = this
						this.sendMsgDisabled = true
						const interval = window.setInterval(function() {
							that.time--
							if ((that.time) < 0) {
								that.time = 120
								that.sendMsgDisabled = false
								window.clearInterval(interval)
							}
						}, 1000)
					} else {
						this.$message({
							message: '验证码发送失败',
							type: 'warning'
						});
					}
				})
			},
		},
	}
</script>

<style scoped>
	.login {
		position: fixed;
		left: 0;
		top: 0;
		background: url('../image/loginbackground.jpg');
		background-size: 100% 100%;
		width: 100%;
		height: 100%;
	}

	.infoform {
		background-color: white;
		width: 550px;
		height: 600px;
		margin: auto;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		border-radius: 4px;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.textlogin {
		font-size: 22px;
		padding-top: 4%;
		padding-left: 231px;
	}

	.el-form {
		margin-left: 5%;
		margin-right: 5%;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}

	.lgoinbtn {
		margin-top: 20px;
		width: 120px;
		height: 45px;
	}

	.roundbtn {
		width: 550px;
	}

	.sendcode {
		display: flex;
	}

	.back_login {
		margin-top: 20px;
		width: 120px;
		height: 45px;
		margin-left: 30%;
	}

	.footer {
		margin-top: 10px;
	}
</style>
